import api from "@/api";

export default {
    // GET /api/cong-trinh
    getAll() {
        return api.get('/api/cong-trinh');
    },

    // GET /api/cong-trinh/{id}
    getDetail(id) {
        return api.get(`/api/cong-trinh/${id}`);
    },

    // POST /api/cong-trinh
    create(data) {
        return api.post('/api/cong-trinh', data);
    },

    // PUT /api/cong-trinh/{id}
    update(id, data) {
        return api.put(`/api/cong-trinh/${id}`, data);
    },

    // DELETE /api/cong-trinh/{id}
    delete(id) {
        return api.delete(`/api/cong-trinh/${id}`);
    },

    getUserOptions() {
        return api.get('/api/nguoi-dung/options');
    }
};